import React from 'react'
import Layout from '../../shared/components/organisms/layout/layout'
import SEO from "../../shared/seo";
import CategoryProducts from '../organisms/category-products/category-products';

const CategoryTemplate = props => {
    const [isMobile, setMobileBool] = React.useState(false);

    const updateDimensions = () => {
        setMobileBool(window.innerWidth < 1024 ? true : false);
    }

    React.useEffect(() => {
        updateDimensions();
        window.addEventListener("resize", updateDimensions);
        return () => {
            window.removeEventListener("resize", updateDimensions);
        }
    }, [])

    return (
        <Layout
            mobile={isMobile}
            title={props.pageContext.params.metaTitulo}
        >
            <SEO
                title={props.pageContext.params.metaTitulo}
                description={props.pageContext.params.metaDescripcion.metaDescripcion.split("\n")[0]}
                url={"/productos/" + props.pageContext.slug}
            />
            <CategoryProducts menu={props.pageContext.menu} params={props.pageContext.params} mobile={isMobile} />
        </Layout>
    )
}

export default CategoryTemplate;
